/**
 * Бейдж состояния байка в карточке и во всплывашке на карте.
 *
 * Цвет — статус палитрой bo, тот же, что у метки (`lib/map-marker.ts`):
 * иначе метка оранжевая, а бейдж над ней красный, и один байк выглядит
 * двумя. Текст — по-прежнему ярлык `describeBike` (причина), его передаёт
 * вызывающий.
 *
 * ⚠ ЗАЛИВКА СПЛОШНАЯ, А НЕ 15 % ПРОЗРАЧНОСТИ, КАК У `Chip`. Всплывашка
 * белая, карточка тёмная: полупрозрачный цвет со светлым текстом на белом не
 * читается, а сплошной читается на обоих и совпадает с меткой один в один.
 */
import type { ReactNode } from 'react'
import { labelColorOn, statusColor } from '@/lib/map-marker'

export function StatusChip({ status, children }: { status: string; children: ReactNode }) {
  const fill = statusColor(status)
  return (
    <span
      className="inline-block rounded-full px-3 py-1 text-xs font-medium"
      style={{ background: fill, color: labelColorOn(fill) }}
    >
      {children}
    </span>
  )
}
